import React, { Component } from "react";
import Slider from "react-slick";

const LearnAnimation = React.lazy(() => import("./LearnRealm"));
const InvestAnimation = React.lazy(() => import("./InvestRealm"));
const PlayAnimation = React.lazy(() => import("./PlayRealm"));
const DoGoodAnimation = React.lazy(() => import("./DoGoodRealm"));

const LearnTextAnimation = React.lazy(() => import("./LearnRealmText"));
const InvestTextAnimation = React.lazy(() => import("./InvestRealmText"));
const PlayTextAnimation = React.lazy(() => import("./PlayRealmText"));
const DoGoodTextAnimation = React.lazy(() => import("./DoGoodRealmText"));

export default class RealmsSlider extends Component {
  render() {
    const settings = {
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="realms-slider">
        <Slider {...settings}>
          <div>
            <RealmPlay />
          </div>
          <div>
            <RealmInvest />
          </div>
          <div>
            <Realmlearn />
          </div>
          <div>
            <RealmIDoGood />
          </div>
        </Slider>
      </div>
    );
  }
}

const RealmPlay = () => {
  return (
    <div className="realms-slider-item">
      <PlayAnimation />
      <div className="realm-info play">
        <PlayTextAnimation />
        Games, entertainment and fun in a joyful environment where unique
        engagement surrounds us all
      </div>
    </div>
  );
};

const RealmInvest = () => {
  return (
    <div className="realms-slider-item">
      <InvestAnimation />
      <div className="realm-info invest">
        <InvestTextAnimation />
        Support the next generation of dreamers and builders and connect with
        like-minded believers in Web3
      </div>
    </div>
  );
};

const Realmlearn = () => {
  return (
    <div className="realms-slider-item">
      <LearnAnimation />
      <div className="realm-info learn">
        <LearnTextAnimation />
        Idea exchange, learning, discovery, and non-linear growth in a limitless
        space for uniting Web3 insights
      </div>
    </div>
  );
};

const RealmIDoGood = () => {
  return (
    <div className="realms-slider-item">
      <DoGoodAnimation />
      <div className="realm-info dogood">
        <DoGoodTextAnimation />
        Contribute to society and protect our surrounding environments for a
        better future that benefits everyone
      </div>
    </div>
  );
};
